import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { Button } from './button.tsx';
import { goToNextOnboardingStep, Message } from './common.tsx';
import { Frame } from './frame.tsx';

export const SubscribeFindHousehold = () => {
  const navigate = useNavigate();

  const onFindHousehold = useCallback(async () => {
    await goToNextOnboardingStep(navigate, {
      from: OnboardingPages.SubscribeFindHousehold,
      action: 'alreadyHaveHousehold',
    });
  }, [navigate]);

  const onNewHousehold = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.SubscribeFindHousehold, action: 'newHousehold' });
  }, [navigate]);

  return (
    <Frame
      onboardingPage={OnboardingPages.SubscribeFindHousehold}
      mainContent={<Message $widthInChars={18}>Have you already created a household?</Message>}
      footerContent={
        <>
          <Button onClick={onFindHousehold}>I ALREADY HAVE A HOUSEHOLD</Button>
          <Button onClick={onNewHousehold}>CREATE NEW HOUSEHOLD</Button>
        </>
      }
      onEnterKeypress={onFindHousehold}
    />
  );
};
